module.exports = __webpack_public_path__ + "img/Cong_Tony_XU.adb86936.png";